// extracted by mini-css-extract-plugin
export default {"tasks":"GL-z","task":"HL-z","svg":"IL-z","text":"JL-z"};